if (!customElements.get('sticky-variant')) {
  class StickyVariant extends HTMLElement {
    constructor() {
      super()

      this.buttons = Array.from(this.querySelectorAll('.js-variant-button'))
      this.buttons.map((button, index) => {
        button.addEventListener('click', () => this.onVariantChange(button))
      })
    }

    onVariantChange(button) {
      this.querySelector('details').removeAttribute('open');
      if (button.classList.contains('is-active')) return
      this.querySelector('.is-active').classList.remove('is-active')
      button.classList.toggle('is-active')
      this.updateSummary(button)
      document.getElementById(button.dataset.target).click()
    }

    updateSummary(button) {
      this.querySelector('summary button').innerHTML = button.innerHTML 
    }
  }

  customElements.define('sticky-variant', StickyVariant)

  const stickyVariantsScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const productFormPosition = document.querySelector(
      '.product-form__quantity'
    ).offsetTop + 500
    document
      .querySelector('.js-sticky-cta')
      .classList.toggle('is-visible', scrollTop > productFormPosition)
  }
  window.addEventListener('scroll', stickyVariantsScroll, false)
  window.addEventListener('load', stickyVariantsScroll, false)
}

// Remove transparent header class when vertically bleed is disabled
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.grid__item--under-nav')) {
    document.querySelector('.header').removeAttribute('data-is-transparent')
  }
})
